/* Laleblu — alvo de frete grátis por região.
   Regra: enquanto a região da cliente não for conhecida, NENHUM valor é exibido. */
(function () {
  'use strict';

  var STORAGE_KEY = 'laleblu_frete_uf';

  var TIER_SUDESTE_SUL_CO = 699;
  var TIER_NORTE_NORDESTE = 799;
  var TIER_SP_CAPITAL = 399;
  var TIER_SP_ESTADO = 599;

  var MID_TIER_UFS = ['RJ', 'ES', 'MG', 'PR', 'SC', 'RS', 'GO', 'MT', 'MS', 'DF'];

  var ALL_UFS = ['AC','AL','AM','AP','BA','CE','DF','ES','GO','MA','MG','MS','MT','PA','PB','PE','PI','PR','RJ','RN','RO','RR','RS','SC','SE','SP','TO'];

  var RANGES = [
    [1000, 19999, 'SP'],
    [20000, 28999, 'RJ'],
    [29000, 29999, 'ES'],
    [30000, 39999, 'MG'],
    [40000, 48999, 'BA'],
    [49000, 49999, 'SE'],
    [50000, 56999, 'PE'],
    [57000, 57999, 'AL'],
    [58000, 58999, 'PB'],
    [59000, 59999, 'RN'],
    [60000, 63999, 'CE'],
    [64000, 64999, 'PI'],
    [65000, 65999, 'MA'],
    [66000, 68899, 'PA'],
    [68900, 68999, 'AP'],
    [69000, 69299, 'AM'],
    [69300, 69399, 'RR'],
    [69400, 69899, 'AM'],
    [69900, 69999, 'AC'],
    [70000, 72799, 'DF'],
    [72800, 72999, 'GO'],
    [73000, 73699, 'DF'],
    [73700, 76799, 'GO'],
    [77000, 77999, 'TO'],
    [78000, 78899, 'MT'],
    [78900, 78999, 'RO'],
    [79000, 79999, 'MS'],
    [80000, 87999, 'PR'],
    [88000, 89999, 'SC'],
    [90000, 99999, 'RS']
  ];

  function onlyDigits(value) {
    return String(value == null ? '' : value).replace(/[^0-9]/g, '');
  }

  function prefixFromCep(cep) {
    var digits = onlyDigits(cep);
    if (digits.length < 8) return null;
    return parseInt(digits.slice(0, 5), 10);
  }

  function ufFromPrefix(prefix) {
    for (var i = 0; i < RANGES.length; i++) {
      if (prefix >= RANGES[i][0] && prefix <= RANGES[i][1]) return RANGES[i][2];
    }
    return null;
  }

  function isSaoPauloCapital(prefix) {
    return (prefix >= 1000 && prefix <= 5999) || (prefix >= 8000 && prefix <= 8499);
  }

  function targetFromCep(cep) {
    var prefix = prefixFromCep(cep);
    if (prefix === null) return null;
    var uf = ufFromPrefix(prefix);
    if (!uf) return null;
    if (uf === 'SP') {
      return { uf: uf, target: isSaoPauloCapital(prefix) ? TIER_SP_CAPITAL : TIER_SP_ESTADO };
    }
    return {
      uf: uf,
      target: MID_TIER_UFS.indexOf(uf) !== -1 ? TIER_SUDESTE_SUL_CO : TIER_NORTE_NORDESTE
    };
  }

  function targetFromUf(uf) {
    if (!uf) return null;
    uf = String(uf).toUpperCase();
    if (ALL_UFS.indexOf(uf) === -1) return null;
    if (uf === 'SP') return { uf: uf, target: TIER_SP_ESTADO };
    if (MID_TIER_UFS.indexOf(uf) !== -1) return { uf: uf, target: TIER_SUDESTE_SUL_CO };
    return { uf: uf, target: TIER_NORTE_NORDESTE };
  }

  function readStored() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (parsed && parsed.target) return parsed;
    } catch (e) {}
    return null;
  }

  function store(resolved) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(resolved));
    } catch (e) {}
  }

  function externalCepValue() {
    var field = document.getElementById('cep-frete');
    if (field && field.value) return field.value;
    return null;
  }

  function resolve() {
    var typed = targetFromCep(externalCepValue());
    if (typed) return typed;

    var stored = readStored();
    if (stored) return stored;

    if (window.customerZip) {
      var byZip = targetFromCep(window.customerZip);
      if (byZip) return byZip;
    }
    if (window.customerProvinceCode) {
      var byUf = targetFromUf(window.customerProvinceCode);
      if (byUf) return byUf;
    }
    return null;
  }

  function components() {
    return document.querySelectorAll('free-shipping-component');
  }

  function prompts() {
    return document.querySelectorAll('[data-free-shipping-cep-prompt]');
  }

  function showNeutral() {
    Array.prototype.forEach.call(components(), function (el) {
      el.classList.add('fs-region-unknown');
    });
    Array.prototype.forEach.call(prompts(), function (el) {
      el.style.display = 'block';
    });
  }

  function applyTarget(target) {
    window.free_shipping_price = target;

    var ctor = window.customElements && window.customElements.get('free-shipping-component');
    if (ctor) ctor.freeshipPrice = target;

    Array.prototype.forEach.call(prompts(), function (el) {
      el.style.display = 'none';
    });

    Array.prototype.forEach.call(components(), function (el) {
      el.classList.remove('fs-region-unknown');
      if (typeof el.initialize === 'function') {
        try { el.initialize(); } catch (e) {}
      }
    });
  }

  function refresh(persist) {
    var resolved = resolve();
    if (resolved && resolved.target) {
      if (persist) store(resolved);
      applyTarget(resolved.target);
    } else {
      showNeutral();
    }
  }

  /* Executa cedo (script com defer) para que o alvo já exista quando o
     componente nativo for registrado no evento load. */
  var early = resolve();
  if (early && early.target) window.free_shipping_price = early.target;

  function formatCep(value) {
    var d = onlyDigits(value).slice(0, 8);
    return d.length > 5 ? d.slice(0, 5) + '-' + d.slice(5) : d;
  }

  function bindPrompt(wrap) {
    if (wrap.dataset.freeShippingBound) return;
    wrap.dataset.freeShippingBound = 'true';

    var input = wrap.querySelector('[data-free-shipping-cep-input]');
    var button = wrap.querySelector('[data-free-shipping-cep-submit]');
    var error = wrap.querySelector('[data-free-shipping-cep-error]');

    function submit() {
      var resolved = targetFromCep(input ? input.value : '');
      if (resolved) {
        if (error) error.style.display = 'none';
        store(resolved);
        applyTarget(resolved.target);
      } else if (error) {
        error.style.display = 'block';
      }
    }

    if (input) {
      input.addEventListener('input', function () {
        input.value = formatCep(input.value);
        if (error) error.style.display = 'none';
        if (onlyDigits(input.value).length === 8) submit();
      });
      input.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          submit();
        }
      });
    }

    if (button) button.addEventListener('click', submit);
  }

  function bind() {
    var field = document.getElementById('cep-frete');
    if (field && !field.dataset.freeShippingBound) {
      field.dataset.freeShippingBound = 'true';
      ['change', 'blur', 'input'].forEach(function (evt) {
        field.addEventListener(evt, function () {
          refresh(true);
        });
      });
    }

    Array.prototype.forEach.call(prompts(), bindPrompt);
  }

  function boot() {
    bind();
    refresh(false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('load', function () {
    setTimeout(boot, 300);
  });

  document.addEventListener('click', function (event) {
    if (event.target && event.target.closest && event.target.closest('.preco-frete')) {
      setTimeout(function () { refresh(true); }, 900);
    }
  });

  document.addEventListener('cart:updated', function () { boot(); });
  document.addEventListener('cart:refresh', function () { boot(); });

  /* O carrinho lateral é reinjetado no DOM a cada alteração: reconecta os campos. */
  if (window.MutationObserver) {
    var observer = new MutationObserver(function () {
      bind();
      var resolved = resolve();
      if (resolved && resolved.target) {
        Array.prototype.forEach.call(prompts(), function (el) { el.style.display = 'none'; });
        Array.prototype.forEach.call(components(), function (el) { el.classList.remove('fs-region-unknown'); });
      } else {
        showNeutral();
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
